import React from "react";
import { Link } from "react-router-dom";
import "./Home.css"; // Keep your animations and custom styles here

import heroVideo from "../../assets/Videos/6161372-hd_1920_1080_30fps.mp4";
import precisionImage from "../../assets/images/ai-generated-9002350_1280.jpg";
import automationImage from "../../assets/images/metal-parts-being-treated-with-zinc-coating.jpg";
import sectorsImage from "../../assets/images/portrait-young-worker-hard-hat-large-metalworking-plant.jpg";
import clientsImage from "../../assets/images/wood-3785816_1280.jpg";
import Highlights from "./Highlights";
import AboutUs from "./AboutUs";
import Sectors from "./Sectors"
import Products from "./Products"
import Vision from "./Vision"
import Global from "./Global"
import Service from "./Service"
import Facility from "./Facility"
import Stats from "./Stats"

const Home = () => {
  return (
    <main className="pt-[113px] bg-white text-gray-800">
      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden">
  {/* Video Background */}
  <video
    autoPlay
    muted
    loop
    playsInline
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    style={{ opacity: '85%' }}
  >
    <source src={heroVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Gradient Overlay */}
  <div className="absolute top-0 left-0 w-full h-full z-10 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

  {/* Content Overlay */}
  <div className="relative z-20 h-full flex items-center text-white px-6 md:px-10">
    <div className="max-w-8xl mx-auto flex flex-col md:flex-row items-center gap-10 w-full">
      <div className="md:w-1/2 animate-fade-in">
        <h1
          className="text-4xl md:text-7xl font-bold leading-tight mb-6"
          style={{ width: 'max-content', color: '#E7DFC6' }}
        >
          Premium CED & Powder Coating
        </h1>
        <p
          className="text-4xl mb-6"
          style={{ width: 'max-content', color: '#E9F1F7' }}
        >
          Quality, Affordability, and On-Time Delivery for all metal surfaces.
        </p>

        {/* <Link
          to="/Contact"
          className="bg-yellow-300 text-[#ad2624] font-semibold px-6 py-3 rounded-md hover:bg-white hover:scale-105 transition duration-300"
        >
          Get in Touch
        </Link> */}
        
      </div>
    </div>
  </div>
</section>



      {/* Rest of the Sections */}
      
      <AboutUs/>
    <Sectors/>
     <Facility/>
    <Products/>
  <Vision/>
  <Stats/>
 
  <Service/>
    </main>
  );
};

export default Home;
